'use client';
import ImageBgSection from '../Template/ImageBgSection';
import { Col, Row } from 'antd';
import Heading from '../Heading';
import { useEffect, useRef } from 'react';
import { WATrackerTrackPageView } from '@/utils/wa';
import RichText from '../RichText';
import { useGlobalStore } from '@/hooks/useGlobalStore';
import useALTracker from '@/utils/useALTracker';

interface Props {
    pageTitle: string;
    pageDescription: string;
    pageBgimg: string;
    pageName?: string;
    partyName?: string;
}
/** 适用于 pageDetail  */
const PageHeader = (props: Props) => {
    const globalStore = useGlobalStore();
    const { ALTrackPageLoad } = useALTracker();
    const currentPage = useRef('');
    useEffect(() => {
        // console.log('pageName==================', props.pageName);
        switch (props.pageName) {
            // case 'faq':
            //     WATrackerTrackPageView('RnE/HW/FAQ/Home');
            //     break;

            // case 'dining':
            //     WATrackerTrackPageView('RnE/HW/Dining/Home');
            //     break;

            // case 'plan-your-visit':
            //     WATrackerTrackPageView('RnE/HW/PlanYourVisit/Home');
            //     break;

            // case 'album':
            //     WATrackerTrackPageView('RnE/HW/Photo&Video/Home');
            //     break;

            // case 'albumDetail':
            //     WATrackerTrackPageView('RnE/HW/Photo&Video/Album');
            //     break;

            default: {
                if (props.pageName !== currentPage?.current) {
                    currentPage.current = props.pageName || '';
                    globalStore.setGlobalStore({ pageID: `${props.pageName}/Home` });
                    // WATrackerTrackPageView(`RnE/HW/${props.pageName}/Home`);
                    // if (props.pageName ==='albumDetail') return
                    props.pageName =='albumDetail' ? ALTrackPageLoad(`RnE/HW/album/${props.partyName}`) : ALTrackPageLoad(`RnE/HW/${props.pageName}/Home`);
                }
                break;
            }
        }
        
        
    }, [props.pageName, currentPage ]);

    return (
        <div className='flex flex-col'>
            <ImageBgSection image={props.pageBgimg}>
                <Row
                    gutter={[0, 20]}
                    align={'middle'}
                    justify={'space-between'}
                    className='max-xmd:mt-28 mb-10 xmd:mt-[148px]'
                >
                    <Col xs={24} lg={10}>
                        <Heading
                            className='text-base-font-color'
                            level={1}
                            text={props.pageTitle || ''}
                            style={{ color: '#FFFFFF' }}
                        />
                    </Col>
                    <Col xs={24} lg={12}>
                        <RichText
                            className='text-base-font-color'
                            html={props.pageDescription || ''}
                        />
                    </Col>
                </Row>
            </ImageBgSection>
        </div>
    );
};

export default PageHeader;
